import HeroBg from "public/sdnSdwan/Network-SDN.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Compare Our Plans",
    link: "comparison",
  },
  button2: {
    label: "Contact Us",
    link: "contact-us",
  },
  title: "Intelligent Networking: Secure, Agile, and Software-Defined",
  desc: "Unlock next-gen networking with secure, cloud-ready, software-defined infrastructure—built for agility, visibility, and control.",
  image: HeroBg,
};
